var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import { useMount } from 'react-use';
import { ChatMessageRole } from 'shared/domains/apollo/generated/types';
import { WorkflowCheckResponseDocument } from './WorkflowCheckResponse.gql';
import { WorkflowCheckResponseMessagesDocument } from './WorkflowCheckResponseMessages.gql';
import { zUserMessageSchema } from './schema';
const WORKFLOW_NOT_FOUND_SUBCODE = 'WORKFLOW_NOT_FOUND';
export const useWorkflowCheckResponse = (documentChatId) => {
    const [requirementCheckedState, setWorkflowCheckResponseState] = useState({
        type: 'loading',
    });
    const [queryMessages] = useLazyQuery(WorkflowCheckResponseMessagesDocument);
    const [queryPrompt] = useLazyQuery(WorkflowCheckResponseDocument, { errorPolicy: 'all' });
    const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        setWorkflowCheckResponseState({ type: 'loading' });
        try {
            const { data } = yield queryMessages({ variables: { documentChatId } });
            const messages = ((_a = data === null || data === void 0 ? void 0 : data.documentWorkflowChat) === null || _a === void 0 ? void 0 : _a.messages) || [];
            const userMessage = messages.find((message) => message.role === ChatMessageRole.User);
            const plaiMessage = messages.find((message) => message.role === ChatMessageRole.Assistant);
            const plaiResponse = (_b = plaiMessage === null || plaiMessage === void 0 ? void 0 : plaiMessage.content) !== null && _b !== void 0 ? _b : '';
            const additionalContext = (_c = userMessage === null || userMessage === void 0 ? void 0 : userMessage.content) !== null && _c !== void 0 ? _c : undefined;
            const { success, data: parsedUserMessage } = zUserMessageSchema.safeParse(userMessage);
            if (!success) {
                setWorkflowCheckResponseState({ type: 'error', code: 'ERR:PARSING' });
                return;
            }
            const { workflowId } = parsedUserMessage.data;
            const { data: workflowData, errors: workflowErrors } = yield queryPrompt({ variables: { workflowId } });
            const workflowSubcode = (_e = (_d = workflowErrors === null || workflowErrors === void 0 ? void 0 : workflowErrors[0]) === null || _d === void 0 ? void 0 : _d.extensions) === null || _e === void 0 ? void 0 : _e.subcode;
            let workflowUsed;
            if (workflowData === null || workflowData === void 0 ? void 0 : workflowData.workflow) {
                workflowUsed = { name: workflowData.workflow.name };
            }
            else if (workflowSubcode === WORKFLOW_NOT_FOUND_SUBCODE) {
                workflowUsed = null;
            }
            else {
                setWorkflowCheckResponseState({ type: 'error', code: 'ERR:WORKFLOW' });
                return;
            }
            setWorkflowCheckResponseState({
                type: 'finished',
                plaiResponse,
                additionalContext,
                workflowUsed,
            });
        }
        catch (_f) {
            setWorkflowCheckResponseState({ type: 'error', code: 'ERR:FAILED' });
        }
    });
    useMount(fetchData);
    return { requirementCheckedState };
};
